// -------------------- generic -------------------- //
export const STORE_ITEMS = 'STORE_ITEMS';
export const SUBMIT_UPDATE_ITEM = 'SUBMIT_UPDATE_ITEM';
export const UPDATE_ITEM = 'UPDATE_ITEM';
export const SUBMIT_DELETE_ITEM = 'SUBMIT_DELETE_ITEM';
export const DELETE_ITEM = 'DELETE_ITEM';
export const OPEN_ADD_MODAL = 'OPEN_ADD_MODAL';
export const CLOSE_ADD_MODAL = 'CLOSE_ADD_MODAL';
export const OPEN_EDIT_MODAL = 'OPEN_EDIT_MODAL';
export const CLOSE_EDIT_MODAL = 'CLOSE_EDIT_MODAL';
export const OPEN_DELETE_MODAL = 'OPEN_DELETE_MODAL';
export const CLOSE_DELETE_MODAL = 'CLOSE_DELETE_MODAL';
export const FINISH_PENDING = 'FINISH_PENDING';
export const RESET_STATE = 'RESET_STATE';
export const SUBMIT_ADD_ITEM = 'SUBMIT_ADD_ITEM';
export const LOAD_MORE = 'LOAD_MORE';

// -------------------- user -------------------- //
export const SAVE_USER_INFO = 'SAVE_USER_INFO';
export const SAVE_ORGANISATIONS_INFO = 'SAVE_ORGANISATIONS_INFO';
export const SAVE_DEVICES_INFO = 'SAVE_DEVICES_INFO';
export const FAIL_CHECK = 'FAIL_CHECK';
export const APPROVE_CHECK = 'APPROVE_CHECK';
export const SUBMITTED_PROFILE = 'SUBMITTED_PROFILE';
export const PROFILE_SET = 'PROFILE_SET';
export const NEW_PROFILE_INVALIDATED = 'NEW_PROFILE_INVALIDATED';
export const SUBMIT_PROFILE_UPDATE = 'SUBMIT_PROFILE_UPDATE';
export const STORE_UPDATED_PROFILE = 'STORE_UPDATED_PROFILE';
export const OPEN_PROFILE_UPDATE_MODAL = 'OPEN_PROFILE_UPDATE_MODAL';
export const CLOSE_PROFILE_UPDATE_MODAL = 'CLOSE_PROFILE_UPDATE_MODAL';
export const INVALIDATE_PROFILE_UPDATE = 'INVALIDATE_PROFILE_UPDATE';
// -------------------- login -------------------- //
export const INITIATE_LOGIN = 'INITIATE_LOGIN';
export const INVALIDATE_LOGIN = 'INVALIDATE_LOGIN';
export const INITIATE_RESET_PASSWORD = 'INITIATE_RESET_PASSWORD';
export const RESET_EMAIL_SENT = 'RESET_EMAIL_SENT';
export const RESET_EMAIL_ERROR = 'RESET_EMAIL_ERROR';
// -------------------- settings -------------------- //
export const SAVE_ORGANISATION_MACHINES = 'SAVE_ORGANISATION_MACHINES';
export const SAVE_SETTINGS_MACHINES = 'SAVE_SETTINGS_MACHINES';
// -------------------- telemetry -------------------- //
export const INVALIDATE_TELEMETRY = 'INVALIDATE_TELEMETRY';
export const STORE_TELEMETRY = 'STORE_TELEMETRY';



// WEBPACK FOOTER //
// ./src/actions/actionTypes.js